const usageNumberFormatterV815 = new Intl.NumberFormat();

const formatUsageNumberV815 = (value) => {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed)
    ? usageNumberFormatterV815.format(parsed)
    : String(value ?? 0);
};

export const buildLedgerUsageV815 = (entry, internal, t) => {
  const imageCount = Number(entry?.image_units || 0);
  const input = formatUsageNumberV815(entry?.input_units);
  const output = formatUsageNumberV815(entry?.output_units);

  if (imageCount <= 0) {
    return {
      hasImages: false,
      primary: t('billing.usage.tokens', { input, output }),
      secondary: '',
    };
  }

  const imageOutputTokens = Number(entry?.image_output_tokens || 0);
  const secondary =
    internal && imageOutputTokens > 0
      ? t('billing.usage.image_token_breakdown', {
          input,
          output,
          imageOutput: formatUsageNumberV815(imageOutputTokens),
        })
      : t('billing.usage.image_token_totals', { input, output });

  return {
    hasImages: true,
    primary: t('billing.usage.images', {
      count: formatUsageNumberV815(imageCount),
    }),
    secondary,
  };
};
